import { Link } from "react-router-dom";
import BrandMark from "@/components/feature/BrandMark";
import { serviceGroups } from "@/mocks/services";
import { site } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="shell py-14 md:py-18">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-6">
          <div className="lg:col-span-2">
            <Link to="/" aria-label={`${site.name} anasayfa`} className="cursor-pointer">
              <BrandMark tone="light" />
            </Link>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-200/80">
              {site.tagline}. Modern dijital cihazlar, aynı gün dijital rapor ve diş hekimleri için
              güvenilir bir görüntüleme ortaklığı.
            </p>
            <div className="mt-6 flex flex-col gap-2.5 text-sm">
              <a
                href={site.phoneMainHref}
                className="flex cursor-pointer items-center gap-2.5 text-background-100 transition-colors hover:text-accent-300"
              >
                <i className="ri-whatsapp-line text-base text-accent-400" aria-hidden="true" />
                {site.phoneMain} (WhatsApp)
              </a>
              <a
                href={site.phoneLandHref}
                className="flex cursor-pointer items-center gap-2.5 text-background-100 transition-colors hover:text-accent-300"
              >
                <i className="ri-phone-line text-base text-accent-400" aria-hidden="true" />
                {site.phoneLand}
              </a>
              <a
                href={`mailto:${site.email}`}
                className="flex cursor-pointer items-center gap-2.5 text-background-100 transition-colors hover:text-accent-300"
              >
                <i className="ri-mail-line text-base text-accent-400" aria-hidden="true" />
                {site.email}
              </a>
            </div>
          </div>

          <div>
            <h2 className="font-heading text-xs font-semibold uppercase tracking-[0.2em] text-accent-300">
              2D Görüntüleme
            </h2>
            <ul className="mt-5 flex flex-col gap-3">
              {serviceGroups[0].items.map((item) => (
                <li key={item.slug}>
                  <Link
                    to="/hizmetler"
                    className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-background-50"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-xs font-semibold uppercase tracking-[0.2em] text-accent-300">
              3D Tomografi
            </h2>
            <ul className="mt-5 flex flex-col gap-3">
              {serviceGroups[1].items.map((item) => (
                <li key={item.slug}>
                  <Link
                    to="/hizmetler"
                    className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-background-50"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>

            <h2 className="mt-8 font-heading text-xs font-semibold uppercase tracking-[0.2em] text-accent-300">
              Kurumsal
            </h2>
            <ul className="mt-5 flex flex-col gap-3">
              <li>
                <Link to="/hakkimizda" className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-background-50">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/dis-hekimleri" className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-background-50">
                  Diş Hekimleri İçin
                </Link>
              </li>
              <li>
                <Link to="/hasta-bilgilendirme" className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-background-50">
                  Hasta Bilgilendirme
                </Link>
              </li>
              <li>
                <Link to="/neden-dmar" className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-background-50">
                  Neden d.mar?
                </Link>
              </li>
              <li>
                <Link to="/sss" className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-background-50">
                  Sıkça Sorulan Sorular
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-background-50">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h2 className="font-heading text-xs font-semibold uppercase tracking-[0.2em] text-accent-300">
              Merkez & Çalışma Saatleri
            </h2>
            <ul className="mt-5 flex flex-col gap-3 text-sm text-background-200/85">
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line mt-0.5 text-base text-accent-400" aria-hidden="true" />
                <span>{site.address}</span>
              </li>
              <li>
                <a
                  href={site.directions}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex cursor-pointer items-center gap-2.5 text-background-100 transition-colors hover:text-accent-300"
                >
                  <i className="ri-road-map-line text-base text-accent-400" aria-hidden="true" />
                  Yol tarifi al
                </a>
              </li>
            </ul>
            <dl className="mt-5 flex flex-col gap-2.5 text-sm">
              {site.hours.map((row) => (
                <div key={row.day} className="flex items-center justify-between gap-4 border-b border-background-50/10 pb-2">
                  <dt className="text-background-200/80">{row.day}</dt>
                  <dd className="font-semibold text-background-100">{row.value}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="shell flex flex-col items-center justify-between gap-3 py-6 text-xs text-background-200/70 sm:flex-row">
          <p>© {year} d.mar Dental Görüntüleme Merkezi. Tüm hakları saklıdır.</p>
          <p className="text-background-200/60">
            Dental radyoloji &amp; görüntüleme merkezi · Osmanbey / Şişli, İstanbul
          </p>
        </div>
      </div>
    </footer>
  );
}